import { isEmpty } from './ValidForm';

export function printToast({ severity = 'success', summary = '', detail = '' }) {
    let maiorMessage = summary.length > detail.length ? summary : detail;
    let messageLength = maiorMessage.split(' ').length;
    let life = (messageLength * 60000) / 100;
    window.$toast.current.show({ severity, summary, detail, life });
}

export function classNames(parm) {
    let classes = '';

    for (let key of Object.keys(parm)) {
        if (parm[key]) {
            classes += ` ${key}`;
        }
    }

    return classes;
}

export function getRandomNumber() {
    return Math.floor(Math.random() * 10000000);
}

export function Left(str, n) {
    if (n <= 0) return '';
    else if (n > String(str).length) return str;
    else return String(str).substring(0, n);
}
export function Right(str, n) {
    if (n <= 0) return '';
    else if (n > String(str).length) return str;
    else {
        var iLen = String(str).length;
        return String(str).substring(iLen, iLen - n);
    }
}

export function bindParams(url, params) {
    Object.keys(params).forEach((param) => {
        url = url.replace(`:${param}`, params[param]);
    });
    return url;
}

export function addMaskOnString(string, maskInput) {
    if (isEmpty(string)) return string;

    const addMask = (value, character = '.') => {
        const masks = maskInput.split(character);
        value = `${value}`;
        let retorno = '';
        let last = 0;

        for (let i = 0; i < masks.length; i++) {
            const elLength = masks[i].length;
            let atual = `${character}${Left(Right(value, value.length - last), elLength)}`;
            if (i === 0) {
                atual = Left(value, elLength);
            } else if (i === masks.length - 1) {
                atual = `${character}${Right(value, elLength)}`;
            }
            retorno += atual;
            last += elLength;
        }

        return retorno;
    };

    let retorno = addMask(string, '.');
    retorno = addMask(retorno, '/');
    retorno = addMask(retorno, '-');
    return retorno;
}

export const assignRefs = (...refs) => {
    return (node) => {
        refs.forEach((r) => {
            if (typeof r === 'function') {
                r(node);
            } else if (r) {
                r.current = node;
            }
        });
    };
};

export const labelToChart = (label) => {
    let retorno = [label];
    const maxLength = 30;
    if (label.length > maxLength) {
        const words = label.split(' ');
        let newLine = '';
        for (let i = 0; i < words.length; i++) {
            const word = words[i];
            const validateNewLine = `${isEmpty(newLine) ? newLine : `${newLine} `}${word}`;
            if (validateNewLine.length > maxLength) {
                break;
            } else {
                newLine = validateNewLine;
            }
        }

        retorno = [
            newLine.trim(),
            ...labelToChart(Right(label, label.length - newLine.trim().length).trim(), true),
        ];
    }

    return retorno;
};
